import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_a_legally_required_fire_brigadeemergency_resp'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_a_legally_required_fire_brigadeemergency_resp',
  name: 'Does the facility have a legally required Fire Brigade/Emergency Response Team of designated workers with special responsibilities for fire safety?',
  description:
    'Consult applicable legal requirements. \r\r\n\r\r\nSpecial responsibilities for fire safety are measures to be taken beyond using a fire extinguisher to put out a small fire.\r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-eme-11',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 15080,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
